import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IAuFiltersConfig } from '@app/configs/filters/au-configurable-filters.config';
import { AuUtilsFunctions } from '@app/shared';
import { IConfigurableMultiselectData } from '@shared/ui-components/au-configurable-filter/interfaces/au-configurable-filter.interfaces';

interface INameAndId {
	id: string;
	name: string;
}

export class ConfigurableFilterBase {
	protected config: IAuFiltersConfig;

	formGroupFilters: UntypedFormGroup;

	firstSelectEntitiesList: any[];
	firstSelectDefaultValue: string[] | string;

	secondSelectEntitiesList: any[];
	secondSelectDefaultValue: string[] | string;

	constructor(protected fb: UntypedFormBuilder) {}

	initForm() {
		this.formGroupFilters = this.fb.group({
			[this.config.fieldsConfig.firstSelect.formControlName]: [],
			[this.config.fieldsConfig.secondSelect.formControlName]: [],
			[this.config.fieldsConfig.searchField.formControlName]: '',
		});
	}

	get isAllFirstSelectItemsSelected(): boolean {
		if (!this.firstSelectDefaultValue) {
			return false;
		}
		return (
			this.firstSelectDefaultValue.length ===
			this.formGroupFilters.get(this.firstFormControlName).value?.length
		);
	}

	get isAllSecondSelectItemsSelected(): boolean {
		if (!this.secondSelectEntitiesList) {
			return false;
		}
		return (
			this.secondSelectEntitiesList.length ===
			this.formGroupFilters.get(this.secondFormControlName).value?.length
		);
	}

	protected addToEntitiesListNullValue(
		entityList: INameAndId[],
		filterFieldsConfig: IConfigurableMultiselectData
	): INameAndId[] {
		return filterFieldsConfig.addNullValueOption
			? this.addEmptyValueToList(entityList, filterFieldsConfig)
			: entityList;
	}

	private addEmptyValueToList(entityList, filterFieldsConfig) {
		const entityListCopy = AuUtilsFunctions.deepCopyObject(entityList);
		entityListCopy.push({
			id: '',
			name: this.getEmptyItemName(filterFieldsConfig),
		});

		return entityListCopy;
	}

	private getEmptyItemName(filterFieldsConfig): string {
		return filterFieldsConfig.labelForNullValueOption
			? filterFieldsConfig.labelForNullValueOption
			: `No ${filterFieldsConfig.placeholder}`;
	}

	get firstSelectConfig() {
		return this.config.fieldsConfig.firstSelect;
	}

	get secondSelectConfig() {
		return this.config.fieldsConfig.secondSelect;
	}

	get firstFormControlName() {
		return this.config.fieldsConfig.firstSelect.formControlName;
	}

	get secondFormControlName() {
		return this.config.fieldsConfig.secondSelect.formControlName;
	}

	get firstOptionsName() {
		return this.config.fieldsConfig.firstSelect.listOfOptions;
	}

	get secondOptionsName() {
		return this.config.fieldsConfig.secondSelect.listOfOptions;
	}
}
